import { Card } from "antd";
import { Colours } from "@modules";
import { Breadcrumb } from "@components";
import { useParams } from "react-router-dom";

export default function ViewPage() {
  const { id } = useParams();

  return (
    <div className="container max-content">
      <Breadcrumb
        data={[
          { title: "Wine Colours", href: "/colors" },
          { title: "Details", href: `/colors/view/${id}` },
        ]}
      />
      <h1 className="mb-8 text-3xl">Wine Color Details</h1>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12">
          <Card bordered={false}>
            <Colours.View id={id} />
          </Card>
        </div>
      </div>
    </div>
  );
}
